module.exports = "/_next/static/images/gb-sct-1225e699061c4d3b9851b6b52e655f24.svg";